import { Box, Divider, Typography, withStyles } from "@material-ui/core";
import React from 'react';
import config from '../_config/config';

const styles = theme => ({
    main: {
        width: '100%',
        // padding: 15,
        // boxShadow: '0 3px 9px rgb(0 0 0 / 16%)',
        display: 'flex',
        backgroundColor: '#F4F4F4',
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center',
        }
    },
    paper: {
        display: "flex",
        width: "55vw",
        height: "60vh",
        minHeight: "350px",
        minWidth: "300px",
    },
    boxstyle: {
        flex: "1",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingLeft: "10%",
        paddingRight: "10%"
    },
    contactsMain: {
        display: "flex",
        flexDirection: "row",
        flex: 1,
        justifyContent: "flex-end",
        alignItems: "center",
        paddingRight: 20,
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        }
    },
    contactContainer: {
        display: "flex",
        flexDirection: "row",
        // flex: 1,
        justifyContent: "flex-end",
        alignItems: "center",
    },
    contactImage: {
        // marginLeft: 10,
        marginRight: 10,
        // height: "4vh",
        height: 16,
    },
    contactText: {
        fontSize: 12,
        whiteSpace: 'nowrap',
    },
    contactDivider: {
        width: 1,
        height: "50%",
        // paddingTop: 10,
        // paddingBottom: 10,
        marginLeft: 10,
        marginRight: 10,
    }
});

function _Header({ classes }) {

    const Contact = ({ image, imageSize, alt_text, text, link }) => {
        return (
            <Box
                className={classes.contactContainer}
                style={{
                    cursor: link ? "pointer" : ""
                }}
                onClick={e => link && link(e)}>
                <img
                    src={image}
                    alt={alt_text}
                    //  height={`${imageSize}vh`} 
                    className={classes.contactImage} ></img>
                <Typography className={classes.contactText}>
                    {text}
                </Typography>
            </Box>
        )
    }

    return (
        <Box className={classes.main}>
            <img
                style={{
                    // height: "75%",
                    // width: "75%"
                    maxHeight: 40,
                    // position: "absolute",
                    // top: 0,
                    // left: 0,
                    margin: '8px 20px',
                    cursor: 'pointer',
                }}
                src={'../images/tradebulls-logo.svg'}
                alt="header logo image"
                onClick={() => window.location.href = config.contentendpoint}
            />
            <Box className={classes.contactsMain}>
                <Contact
                    image={"../images/icon_callivr.svg"}
                    imageSize={3}
                    text={'022 40001000'} />
                <Divider className={classes.contactDivider} />
                <Contact
                    image={"../images/icon_wecare.svg"}
                    imageSize={4}
                    text={'wecare@tradebulls.in'}
                    link={e => {
                        window.location = 'mailto:wecare@tradebulls.in';
                        e.preventDefault();
                    }} />
            </Box>
        </Box>
    )
}

export default withStyles(styles)(_Header);
